export const isRoutingDisabled = (props) => {
  return 'url' in props && !!props.url;
};
